import { connect } from 'react-redux';
import React, { Component } from 'react';
import Layout from '../../components/Layout';
import { chatActions } from "../../store/chat";
import Loading from '../../components/Base/Loading';
import { schoolSelectors } from "../../store/school";
import SearchFaculty from '../../pages/SearchFaculty';
import { searchFacultyActions, searchFacultySelectors } from "../../store/searchFaculty";

class SearchFacultyContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			width: 0,
			height: 0,
			students: [],
			searchTerm: '',
		};

		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}

	componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
		this.getStudentListener();
	}

	getStudentListener = () => {
		this.props.firebase.faculties().orderBy('last_name', 'asc').onSnapshot((snapshot) => {
			let result = [];
			snapshot.forEach(doc => (result.push({ id: doc.id, ...doc.data() })));
			this.props.updateFaculties(result);
		}
		);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
	}

	updateWindowDimensions() {
		this.setState({ width: window.innerWidth, height: window.innerHeight });
	}

	render() {
		const { profile, loadingSchool, students, school } = this.props;

		return (
			<Layout {...this.props} noSideBar>
				{profile === null || loadingSchool === true ? <Loading /> :
					<SearchFaculty {...this.props} width={this.state.width} students={students} school={school} />}
			</Layout>
		);
	}
}

const mapStateToProps = state => {
	return {
		loadingSchool: schoolSelectors.isLoading(state.school),
		schoolInfo: schoolSelectors.refreshSchool(state.school),
		search: searchFacultySelectors.refreshSearch(state.searchFaculty),
		filters: searchFacultySelectors.refreshFilters(state.searchFaculty),
		students: searchFacultySelectors.refreshCurrentResults(state.searchFaculty),
		loading: searchFacultySelectors.isLoading(state.searchFaculty),
		allStudents: searchFacultySelectors.refreshStudents(state.searchFaculty)
	}
};

const mapDispatchToProps = dispatch => ({
	updateSearch: (term) => {
		dispatch(searchFacultyActions.updateSearch(term));
	},
	updateFilter: (filters) => {
		dispatch(searchFacultyActions.updateFilter(filters))
	},
	clearSearch: () => {
		dispatch(searchFacultyActions.clearSearch());
	},
	clearFilter: () => {
		dispatch(searchFacultyActions.clearFilter());
	},
	updateFaculties: (faculties) => {
		dispatch(searchFacultyActions.updateFaculties(faculties))
	},
	updateCurrentChat: (id) => {
		dispatch(chatActions.updateCurrentChat(id))
	}
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchFacultyContainer);
